import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PageHero from '@/components/feature/PageHero';
import ContactForm from '@/components/feature/ContactForm';
import { company } from '@/mocks/company';

const heroImg = '/assets/klob-hero-kontakt.jpg';

const contactCards = [
  { icon: 'ri-phone-line', label: 'Telefon', value: company.phone, href: company.phoneHref, note: 'Mo – Fr erreichbar' },
  { icon: 'ri-mail-line', label: 'E-Mail', value: company.email, href: `mailto:${company.email}`, note: 'Antwort meist innerhalb eines Tages' },
  { icon: 'ri-map-pin-line', label: 'Adresse', value: `${company.street}, ${company.city}`, href: '', note: 'Einsatzgebiet Hollfeld & Umgebung' },
];

const services = [
  'Putz & Stuck',
  'Innen- & Außenputz',
  'Malerarbeiten',
  'Estrich',
  'Fliesenverlegung',
  'Innenausbau',
];

export default function Kontakt() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-50 font-sans">
      <Header />
      <main>
        <PageHero
          eyebrow="Kontakt"
          title={<>Sprechen wir über Ihr <span className="text-primary-500">Vorhaben</span></>}
          subtitle="Ob telefonisch oder über das Formular — beschreiben Sie uns kurz Ihr Projekt. Wir melden uns zeitnah und unverbindlich bei Ihnen."
          image={heroImg}
        />

        <section className="bg-background-50 py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            {contactCards.map((c) => (
              <div
                key={c.label}
                className="rounded-sm border border-background-300/60 bg-background-100 p-6 transition-colors hover:border-primary-500/50"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-sm bg-primary-500/15 text-primary-400">
                  <i className={`${c.icon} text-2xl`}></i>
                </div>
                <p className="mt-5 text-xs uppercase tracking-widest text-foreground-400">{c.label}</p>
                {c.href ? (
                  <a
                    href={c.href}
                    className="mt-1 block text-lg font-semibold text-foreground-50 transition-colors hover:text-primary-400 cursor-pointer break-all"
                  >
                    {c.value}
                  </a>
                ) : (
                  <p className="mt-1 text-lg font-semibold text-foreground-50">{c.value}</p>
                )}
                <p className="mt-2 text-sm text-foreground-400">{c.note}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-50 pb-24 lg:pb-32">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            <div>
              <span className="text-[12px] uppercase tracking-[0.25em] text-primary-400">Anfrage</span>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight text-foreground-50">
                Ihr Projekt — <span className="text-primary-500">unverbindlich anfragen</span>
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-foreground-100/80">
                Je mehr wir über Ihr Vorhaben wissen, desto konkreter können wir antworten. Ein paar Stichworte genügen für den
                Anfang.
              </p>

              <ul className="mt-8 flex flex-col gap-3">
                {services.map((s) => (
                  <li key={s} className="flex items-center gap-2 text-sm text-foreground-100/85">
                    <i className="ri-checkbox-circle-line text-primary-400"></i>
                    {s}
                  </li>
                ))}
              </ul>

              <div className="mt-8 rounded-sm border border-primary-500/30 bg-background-100 px-5 py-5">
                <p className="flex items-start gap-2 text-sm text-foreground-100/85">
                  <i className="ri-information-line text-primary-400 mt-0.5"></i>
                  Kostenloses, unverbindliches Angebot · Keine versteckten Kosten
                </p>
              </div>
            </div>

            <ContactForm formId="kontakt-formular-seite" />
          </div>
        </section>

        <section className="bg-background-100 border-t border-background-300/40 pb-24 lg:pb-28">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20">
            <div className="flex flex-col gap-4 mb-8">
              <span className="text-[12px] uppercase tracking-[0.25em] text-primary-400">Standort</span>
              <h2 className="font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight text-foreground-50">
                So finden Sie <span className="text-primary-500">uns</span>
              </h2>
            </div>
            <div className="relative overflow-hidden rounded-sm border border-background-300/60 bg-background-50 min-h-[420px] flex items-center justify-center px-6 py-12">
              <div className="absolute inset-0 opacity-30 pointer-events-none" aria-hidden="true">
                <div className="absolute left-[8%] top-0 h-full w-px bg-background-300/70 rotate-12"></div>
                <div className="absolute left-[32%] top-0 h-full w-px bg-background-300/50 -rotate-12"></div>
                <div className="absolute right-[25%] top-0 h-full w-px bg-background-300/50 rotate-6"></div>
                <div className="absolute left-0 top-[30%] h-px w-full bg-background-300/60 -rotate-3"></div>
                <div className="absolute left-0 top-[68%] h-px w-full bg-background-300/50 rotate-3"></div>
              </div>
              <div className="relative z-10 max-w-lg text-center">
                <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                  <i className="ri-map-pin-2-line text-3xl"></i>
                </div>
                <h3 className="mt-6 font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight text-foreground-50">
                  Matthias Klob GmbH
                </h3>
                <p className="mt-3 text-foreground-100/80">
                  {company.street}<br />{company.city}
                </p>
                <a
                  href={company.mapsDirectionsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-7 inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-route-line text-lg"></i>
                  Route in Google Maps öffnen
                </a>
                <p className="mt-4 text-xs text-foreground-400 max-w-md mx-auto">
                  Google Maps wird erst geöffnet, wenn Sie auf den Button klicken.
                </p>
              </div>
            </div>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-400">
              <i className="ri-shield-check-line text-primary-400"></i>
              Keine automatische Verbindung zu Google Maps beim Laden dieser Seite.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}